// dashboard/buildTrendSegments.js
//
// Splits a chronologically-sorted survey_submissions array into runs of
// contiguous same-clinical_score_algorithm_version points, for
// TrendChart.js. A single continuous line/fill across a version change
// would visually claim the pet's condition jumped when only the scoring
// method changed (plan §11 risk #5) — this is the fix, extracted as a
// pure function so the split logic itself is directly testable, same
// convention as buildFindingsNarrative.js.
//
// `submitted_at`/`clinical_score_algorithm_version` are the only fields
// read. Null/undefined algorithm_version (pre-clinical_score-column
// history) is its own consistent bucket, never silently merged with a
// real version string.

export function buildTrendSegments(sorted) {
  const segments = [];
  for (const s of sorted) {
    const version = s.clinical_score_algorithm_version ?? '__legacy__';
    const last = segments[segments.length - 1];
    if (last && last.version === version) last.points.push(s);
    else segments.push({ version, points: [s] });
  }
  return segments;
}

// Midpoint x (in the caller's own coordinate space, via `xOf`) between the
// last point of each segment and the first point of the next — one entry
// per boundary, empty array when there's only one segment (no version
// change in the series at all).
export function versionBoundaryPositions(segments, xOf) {
  return segments.slice(1).map((seg, i) => {
    const prevLast = segments[i].points[segments[i].points.length - 1];
    const nextFirst = seg.points[0];
    return (xOf(prevLast) + xOf(nextFirst)) / 2;
  });
}
